module.exports = __webpack_public_path__ + "static/img/1uav2.8dcc522b.png";